import React from "react";

const gradientPaint0Id = "brazeOperatorIcon_paint0_linear";
const gradientPaint1Id = "brazeOperatorIcon_paint1_linear";

export const BrazeOperatorIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity="0.9"
        d="M6.18718 16.0381C6.41694 15.5939 6.53182 15.3718 6.68597 15.2997C6.82018 15.2369 6.97532 15.2369 7.10953 15.2997C7.26368 15.3718 7.37856 15.5939 7.60832 16.0381L8.10019 16.989C8.50714 17.7758 8.71062 18.1692 8.98245 18.5101C9.22366 18.8126 9.50419 19.0838 9.81711 19.3169C10.1698 19.5797 10.5767 19.7764 11.3906 20.1698L12.3053 20.6119C12.7827 20.8426 13.0214 20.958 13.0971 21.1154C13.163 21.2524 13.163 21.4119 13.0971 21.5488C13.0214 21.7063 12.7827 21.8217 12.3053 22.0524L11.3906 22.4945C10.5767 22.8879 10.1698 23.0846 9.81711 23.3473C9.50419 23.5805 9.22366 23.8517 8.98245 24.1542C8.71062 24.4951 8.50714 24.8885 8.10019 25.6752L7.60832 26.6262C7.37856 27.0704 7.26368 27.2925 7.10953 27.3646C6.97532 27.4273 6.82018 27.4273 6.68597 27.3646C6.53182 27.2925 6.41694 27.0704 6.18718 26.6262L5.69531 25.6752C5.28836 24.8885 5.08488 24.4951 4.81305 24.1542C4.57184 23.8517 4.29131 23.5805 3.97839 23.3473C3.62574 23.0846 3.21879 22.8879 2.40489 22.4945L1.49023 22.0524C1.0128 21.8217 0.774089 21.7063 0.698372 21.5488C0.632516 21.4119 0.632516 21.2524 0.698372 21.1154C0.774089 20.958 1.0128 20.8426 1.49023 20.6119L2.40489 20.1698C3.21879 19.7764 3.62574 19.5797 3.97839 19.3169C4.29131 19.0838 4.57184 18.8126 4.81305 18.5101C5.08488 18.1692 5.28836 17.7758 5.69531 16.989L6.18718 16.0381Z"
        fill={`url(#${gradientPaint0Id})`}
      />
      <path
        opacity="0.9"
        d="M16.8842 1.86822C17.1161 1.28542 17.232 0.994023 17.398 0.908261C17.542 0.833891 17.7131 0.833891 17.857 0.90826C18.023 0.994023 18.139 1.28542 18.3709 1.86822L19.4342 4.54067C19.8664 5.62712 20.0826 6.17035 20.4187 6.62729C20.7166 7.03226 21.0826 7.38609 21.5016 7.67405C21.9743 7.99896 22.5362 8.2079 23.6601 8.62576L26.3405 9.62232C26.9639 9.8541 27.2756 9.96999 27.3647 10.1387C27.4419 10.2848 27.4419 10.4596 27.3647 10.6057C27.2756 10.7744 26.9639 10.8902 26.3405 11.122L23.6601 12.1186C22.5362 12.5365 21.9743 12.7454 21.5016 13.0703C21.0826 13.3583 20.7166 13.7121 20.4187 14.1171C20.0826 14.574 19.8665 15.1172 19.4342 16.2037L18.3709 18.8761C18.139 19.4589 18.023 19.7503 17.857 19.8361C17.7131 19.9105 17.542 19.9105 17.3981 19.8361C17.232 19.7503 17.1161 19.4589 16.8842 18.8761L15.8209 16.2037C15.3886 15.1172 15.1725 14.574 14.8364 14.1171C14.5385 13.7121 14.1725 13.3583 13.7535 13.0703C13.2808 12.7454 12.7189 12.5365 11.5949 12.1186L8.91454 11.122C8.29114 10.8902 7.97944 10.7744 7.89035 10.6057C7.81318 10.4596 7.81318 10.2848 7.89035 10.1387C7.97944 9.96999 8.29114 9.8541 8.91454 9.62232L11.5949 8.62576C12.7189 8.2079 13.2808 7.99896 13.7535 7.67405C14.1725 7.38609 14.5385 7.03226 14.8364 6.62729C15.1725 6.17035 15.3886 5.62712 15.8209 4.54067L16.8842 1.86822Z"
        fill={`url(#${gradientPaint1Id})`}
      />
      <defs>
        <linearGradient
          id={gradientPaint0Id}
          x1="-0.00235658"
          y1="26.2545"
          x2="16.7647"
          y2="16.9954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#801ED7" />
          <stop offset="0.5" stopColor="#E9371F" />
          <stop offset="0.8" stopColor="#FFA524" />
        </linearGradient>
        <linearGradient
          id={gradientPaint1Id}
          x1="6.89404"
          y1="18.0291"
          x2="32.9761"
          y2="3.62618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#801ED7" />
          <stop offset="0.5" stopColor="#E9371F" />
          <stop offset="0.8" stopColor="#FFA524" />
        </linearGradient>
      </defs>
    </svg>
  );
};
